<template lang="pug">
    b-modal(v-model="isOpen" hide-footer :title="`Editando Viaje ${delivery ? delivery.drivInCode: ''}`")
      DeliveryForm(v-if="delivery" @done="onDoneDeliveryModal" :delivery="delivery" :editMode="editMode")
</template>

<script>
import DeliveryForm from './DeliveryForm.vue'
export default {
    name: 'DeliveryFormModal',
    components: {
        DeliveryForm
    },
    data() {
        return {
            isOpen: false,
            delivery: null
        }
    },
    methods: {
        onDoneDeliveryModal(event) {
            this.$emit('done')
            this.isOpen = false
        },
        openModal(delivery) {
            this.delivery = delivery || null
            this.isOpen = true
        }
    },
    computed: {
        editMode() {
            return !!this.delivery
        }
    }
}
</script>